/**
 * Логи диагностики, которые не нужны в проде.
 *
 * На кассе консоль не читают, а лишние записи (сканер, синхронизация)
 * засоряют удалённую диагностику. Ошибки и предупреждения остаются
 * обычными `console.error`/`console.warn` — их не глушим.
 */
export function debugLog(...args: unknown[]): void {
  if (import.meta.env?.DEV) console.log(...args)
}
